import { render, staticRenderFns } from "./SelectPoi.vue?vue&type=template&id=fa12c976&scoped=true&"
import script from "./SelectPoi.vue?vue&type=script&lang=js&"
export * from "./SelectPoi.vue?vue&type=script&lang=js&"
import style0 from "./SelectPoi.vue?vue&type=style&index=0&id=fa12c976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa12c976",
  null
  
)

export default component.exports